import { memo, useEffect, useState } from "react";
import { Upload } from ".";
import { CheckCircle2, File, Folder, Loader, XCircle } from "lucide-react";

interface Props {
  upload: Upload;
}

function UploadDetails({ upload }: Props) {
  const [uploading, setUploading] = useState(false);
  const [failed, setFailed] = useState(false);
  const [progress, setProgress] = useState("");

  useEffect(() => {
    if (!upload || upload.status !== "pending") return;
    setUploading(true);
    upload.status = "processing";
    upload
      .handler(upload.data, setProgress)
      .then(() => {})
      .catch(() => setFailed(true))
      .finally(() => {
        upload.status = "done";
        setUploading(false);
      });
  }, [upload]);

  return (
    <div className="flex w-full items-center justify-between px-2 py-2">
      <div className="text-md flex items-center gap-2">
        <span>
          {upload.type === "folder" ? <Folder size={24} /> : <File size={24} />}
        </span>
        <span>{upload.name}</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-md">{progress}</span>
        {uploading ? (
          <Loader className="animate-spin text-blue-500" size={24} />
        ) : failed ? (
          <XCircle className="text-red-500" size={24} />
        ) : (
          <CheckCircle2 className="text-green-500" size={24} />
        )}
      </div>
    </div>
  );
}

export default memo(UploadDetails);
